
import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface SuccessMessageProps {
  email: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ email }) => {
  return (
    <div className="flex flex-col items-center py-4">
      <div className="rounded-full bg-green-50 p-2 mb-4">
        <CheckCircle2 className="h-8 w-8 text-green-500" />
      </div>
      
      <h3 className="text-lg font-medium text-center mb-2">
        Mapp delad
      </h3>
      
      <p className="text-sm text-slate-600 text-center mb-6">
        Mappen har delats med <span className="font-medium">{email}</span>. 
        De kommer att kunna se och arbeta med innehållet i denna mapp.
      </p>
      
      <Button variant="outline" onClick={() => window.location.reload()}>
        Stäng
      </Button>
    </div>
  );
};

export default SuccessMessage;
